import * as d3 from 'd3';

// Two synchronized series: total count of artifacts and total bytes over time.
export function createAssetsOverTimeChart(svgEl) {
  const svg = d3.select(svgEl);
  svg.append('path').attr('class', 'p-count').attr('fill', 'none').attr('stroke', '#4ea1ff').attr('stroke-width', 1.5);
  svg.append('path').attr('class', 'p-bytes').attr('fill', 'none').attr('stroke', '#7ee787').attr('stroke-width', 1.5);
  svg.append('g').attr('class', 'ax');

  function update(snap) {
    const bounds = svgEl.getBoundingClientRect();
    const W = bounds.width, H = bounds.height;
    svg.attr('viewBox', `0 0 ${W} ${H}`);
    const ts = snap.stats.timeSeries;
    if (!ts.length) return;
    const marginL = 28, marginR = 8, marginT = 8, marginB = 16;
    const x = d3.scaleLinear([ts[0].t, ts[ts.length - 1].t + 1], [marginL, W - marginR]);
    const maxCount = d3.max(ts, (d) => (d.artifactCounts?.versions ?? 0) + (d.artifactCounts?.dictionaries ?? 0) + (d.artifactCounts?.deltas ?? 0)) || 1;
    const maxBytes = d3.max(ts, (d) => d.serverBytes?.total ?? 0) || 1;
    const yCount = d3.scaleLinear([0, maxCount], [H - marginB, marginT]);
    const yBytes = d3.scaleLinear([0, maxBytes], [H - marginB, marginT]);
    const lineCount = d3.line().x((d) => x(d.t)).y((d) => yCount((d.artifactCounts?.versions ?? 0) + (d.artifactCounts?.dictionaries ?? 0) + (d.artifactCounts?.deltas ?? 0)));
    const lineBytes = d3.line().x((d) => x(d.t)).y((d) => yBytes(d.serverBytes?.total ?? 0));
    svg.select('path.p-count').attr('d', lineCount(ts));
    svg.select('path.p-bytes').attr('d', lineBytes(ts));

    const ax = svg.select('g.ax');
    ax.selectAll('*').remove();
    ax.append('text').attr('x', marginL).attr('y', marginT + 8).attr('font-size', 10).attr('fill', '#4ea1ff').text('# artifacts');
    ax.append('text').attr('x', W - marginR).attr('y', marginT + 8).attr('text-anchor', 'end').attr('font-size', 10).attr('fill', '#7ee787').text('bytes');
  }
  return { update };
}
